// extracted by mini-css-extract-plugin
export default {"searchGroup":"SearchBar_searchGroup__KM7bs","searchInput":"SearchBar_searchInput__dQo6X","searchButton":"SearchBar_searchButton__6Z21H"};